function* createUser() {
  try {
    yield
  } catch (err) {
    yield
  }
}

export { createUser }
